module.exports = __webpack_public_path__ + "static/media/james-fawcett.858ade42.png";